import { Controller } from "@hotwired/stimulus"

// Kopiert einen vorgegebenen Text in die Zwischenablage und zeigt kurz eine
// Bestaetigung an. Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["confirmation", "copyIcon"]
  static values = { text: String }

  async copy() {
    const text = this.textValue || ""

    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text)
      } else {
        this.fallbackCopy(text)
      }
      this.showConfirmation()
    } catch (error) {
      // Clipboard API kann ohne sicheren Kontext oder Berechtigung fehlschlagen.
      this.fallbackCopy(text)
      this.showConfirmation()
    }
  }

  fallbackCopy(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "absolute"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()
    try {
      document.execCommand("copy")
    } catch (_error) {
      // Letzter Ausweg: nichts weiter zu tun.
    }
    document.body.removeChild(textarea)
  }

  showConfirmation() {
    if (!this.hasConfirmationTarget) return

    this.copyIconTargets.forEach(el => el.classList.add("hidden"))
    this.confirmationTarget.classList.remove("hidden")
    clearTimeout(this.confirmationTimeout)
    this.confirmationTimeout = setTimeout(() => {
      this.confirmationTarget.classList.add("hidden")
      this.copyIconTargets.forEach(el => el.classList.remove("hidden"))
    }, 2000)
  }
}
